<template>
  <nav class="bb-nav" :class="{ scrolled }">
    <div class="bb-nav-inner">
      <RouterLink to="/" class="bb-brand" @click="sendInformationToGoogleAnalitics('website_home')">
        <img src="@/assets/img/logom.png" alt="Bandhoo" class="bb-brand-mark" />
        <span class="bb-brand-name">BANDHOO</span>
      </RouterLink>

      <div class="bb-nav-links">
        <div class="bb-sol" @mouseenter="openSolutions" @mouseleave="closeSolutions">
          <button class="bb-nav-link bb-sol-btn" @click="toggleSolutions">
            Solutions
            <span class="bb-sol-caret" :class="{ open: solOpen }">▼</span>
          </button>
          <div class="bb-sol-panel" :class="{ open: solOpen }">
            <RouterLink
              v-for="link in rolesInfo"
              :key="link.role"
              :to="link.url"
              class="bb-sol-item"
              @click="selectSolution(link.gtag)">
              <span class="bb-sol-item-label">{{ link.role }}</span>
            </RouterLink>
          </div>
        </div>

        <RouterLink
          v-for="link in homeNavLinks"
          :key="link.name"
          :to="link.url"
          class="bb-nav-link"
          @click="sendInformationToGoogleAnalitics(link.gtag)">
          {{ link.name }}
        </RouterLink>
      </div>

      <div class="bb-nav-right">
        <a
          :href="requestDemo.url"
          target="_blank"
          rel="noopener noreferrer"
          class="bb-nav-cta"
          @click="sendInformationToGoogleAnalitics('request_demo')">
          Request Demo →
        </a>
        <button
          class="bb-burger"
          :class="{ open: menuOpen }"
          type="button"
          aria-label="Menu"
          aria-controls="bb-mobile-menu"
          :aria-expanded="menuOpen ? 'true' : 'false'"
          @click="menuOpen = !menuOpen">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>

    <div id="bb-mobile-menu" class="bb-mobile-menu" :class="{ open: menuOpen }">
      <div class="bb-mobile-label">Solutions</div>
      <RouterLink
        v-for="link in rolesInfo"
        :key="link.role"
        :to="link.url"
        class="bb-mobile-link bb-mobile-sub"
        @click="selectMobile(link.gtag)">
        {{ link.role }}
      </RouterLink>
      <div class="bb-mobile-divider"></div>
      <RouterLink
        v-for="link in homeNavLinks"
        :key="link.name"
        :to="link.url"
        class="bb-mobile-link"
        @click="selectMobile(link.gtag)">
        {{ link.name }}
      </RouterLink>
    </div>
  </nav>
</template>

<script>
import { homeNavLinks } from '@/assets/db/home-data'
import { rolesInfo, requestDemo } from '@/assets/db/static-data'
import { GoogleAdsConversions } from '@/assets/db/config'

export default {
  name: 'BandhooNav',
  data() {
    return {
      homeNavLinks,
      rolesInfo,
      requestDemo,
      scrolled: false,
      solOpen: false,
      menuOpen: false,
      closeTimer: null
    }
  },
  methods: {
    onScroll() {
      this.scrolled = window.scrollY > 50
    },
    openSolutions() {
      clearTimeout(this.closeTimer)
      this.solOpen = true
    },
    closeSolutions() {
      this.closeTimer = setTimeout(() => { this.solOpen = false }, 140)
    },
    toggleSolutions() {
      this.solOpen = !this.solOpen
      this.sendInformationToGoogleAnalitics('website_solutions')
    },
    selectSolution(gtagName) {
      this.solOpen = false
      this.sendInformationToGoogleAnalitics(gtagName)
    },
    selectMobile(gtagName) {
      this.menuOpen = false
      this.sendInformationToGoogleAnalitics(gtagName)
    },
    sendInformationToGoogleAnalitics(information) {
      if (!information) {
        return
      }
      if (information === 'request_demo') {
        this.$gtag.event('conversion', GoogleAdsConversions.REQUEST_DEMO_CLICK);
      }
      this.$gtag.event(information);
    }
  },
  watch: {
    '$route'() {
      this.menuOpen = false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: true })
  },
  unmounted() {
    window.removeEventListener('scroll', this.onScroll)
    clearTimeout(this.closeTimer)
  }
}
</script>

<style scoped>
.bb-nav {
  position: sticky;
  top: 0;
  z-index: 200;
  background: var(--bb-navy);
  padding: 0 24px;
  transition: box-shadow 0.3s;
}

.bb-nav.scrolled {
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.28);
}

.bb-nav-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 66px;
}

.bb-brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.bb-brand-mark {
  display: block;
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.bb-brand-name {
  color: #fff;
  font-weight: 900;
  font-size: 18px;
  letter-spacing: 2px;
}

.bb-nav-links {
  display: flex;
  align-items: center;
  gap: 26px;
}

.bb-nav-link {
  color: rgba(255, 255, 255, 0.78);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.2px;
  transition: color 0.2s;
}

.bb-nav-link:hover {
  color: #fff;
}

.bb-sol {
  position: relative;
}

.bb-sol-btn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: inherit;
}

.bb-sol-caret {
  display: inline-block;
  font-size: 10px;
  transition: transform 0.2s;
}

.bb-sol-caret.open {
  transform: rotate(180deg);
}

.bb-sol-panel {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(-8px);
  margin-top: 14px;
  min-width: 240px;
  background: #fff;
  border: 1px solid var(--bb-border-light);
  border-radius: 14px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.22);
  padding: 8px;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.18s, transform 0.18s;
  z-index: 210;
}

.bb-sol-panel.open {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}

.bb-sol-item {
  display: block;
  padding: 12px 14px;
  border-radius: 10px;
  transition: background 0.15s;
}

.bb-sol-item:hover {
  background: #f1f5f9;
}

.bb-sol-item-label {
  display: block;
  color: var(--bb-heading);
  font-weight: 700;
  font-size: 14px;
  line-height: 1.25;
}

.bb-nav-cta {
  background: var(--bb-lime);
  color: var(--bb-navy);
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 800;
  font-size: 13.5px;
  letter-spacing: 0.3px;
  white-space: nowrap;
  transition: background 0.2s;
}

.bb-nav-cta:hover {
  background: var(--bb-lime-hover);
}

.bb-nav-right {
  display: flex;
  align-items: center;
  gap: 14px;
}

.bb-burger {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 40px;
  height: 40px;
  padding: 0 8px;
  background: none;
  border: none;
  cursor: pointer;
}

.bb-burger span {
  display: block;
  height: 2px;
  width: 100%;
  border-radius: 2px;
  background: #fff;
  transition: transform 0.22s, opacity 0.18s;
}

.bb-burger.open span:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.bb-burger.open span:nth-child(2) {
  opacity: 0;
}

.bb-burger.open span:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

.bb-mobile-menu {
  display: none;
  flex-direction: column;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  padding: 10px 0 18px;
}

.bb-mobile-label {
  color: rgba(255, 255, 255, 0.42);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  padding: 14px 4px 8px;
}

.bb-mobile-link {
  color: rgba(255, 255, 255, 0.82);
  font-size: 15px;
  font-weight: 600;
  padding: 12px 4px;
}

.bb-mobile-link:active {
  color: var(--bb-lime);
}

.bb-mobile-sub {
  padding-left: 14px;
}

.bb-mobile-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.12);
  margin: 10px 0 4px;
}

@media (max-width: 760px) {
  .bb-nav-links {
    display: none;
  }

  .bb-burger {
    display: flex;
  }

  .bb-mobile-menu.open {
    display: flex;
  }
}

@media (max-width: 440px) {
  .bb-brand-name {
    display: none;
  }

  .bb-nav-cta {
    padding: 10px 14px;
    font-size: 12.5px;
  }
}
</style>
